"use client";

import { useEffect } from "react";
import { PostHogProvider } from "@posthog/react";
import { POSTHOG_KEY, POSTHOG_HOST, initPixels, registerSuperProps } from "@/lib/analytics";
import { captureUtms } from "@/lib/utm";

const options = {
  api_host: POSTHOG_HOST,
  // Capture les pageviews aussi sur les changements d'historique (URL par étape)
  capture_pageview: "history_change",
} as const;

export function Providers({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initPixels();
    // UTM : capturés sur chaque page, joints à tous les events (super-properties)
    registerSuperProps(captureUtms());
  }, []);

  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
}
